/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CustomerModel from 'cio/models/customer';
import { action } from '@ember/object';
import config from 'cio/config/environment';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import ObjectTypesService from 'cio/services/object-types';
import RelationshipsService from 'cio/services/relationships';

interface Args {
  customer: CustomerModel;
  isCardView?: boolean;
}

export default class PersonRelationshipsTable extends Component<Args> {
  @service objectTypes!: ObjectTypesService;
  @service('relationships') relationshipsService!: RelationshipsService;

  @tracked objectTypeId = '';
  @tracked showRelationshipsModal = false;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    this.relationshipsService.fetchRelationshipsForObjectTypes.perform({ model: args.customer });
  }

  get objectTypeIds() {
    let relationshipObjectTypeIdMap = this.relationshipsService.fetchRelationshipsForObjectTypes.lastSuccessful?.value;

    if (relationshipObjectTypeIdMap == null) {
      return [];
    }

    return relationshipObjectTypeIdMap.filter(({ relationships }) => relationships.length > 0).map(({ id }) => id);
  }

  get canCreateRelationships() {
    return this.objectTypes.canCreateRelationships && this.objectTypes.objectCount > 0;
  }

  @action
  onRelationshipsAdd() {
    this.showRelationshipsModal = false;

    this.relationshipsService.fetchRelationshipsForObjectTypes.perform({
      model: this.args.customer,
      delay: config.APP.relationshipsChangedDelay,
    });
  }
}
